import { TabPanel } from "@mui/lab";
import styled from "styled-components";
import CardTitle from "../../../../components/CardTitle";
import { Box, TextField,    FormControl,  Typography ,Chip} from "@mui/material";


interface StatusTagProps {
  status: 'Active' | 'Pending' | 'Blocked' | string;
}

export const StatusChip = styled(Chip)<StatusTagProps>(({ theme, status }) => ({
  fontWeight: 'bold',
  color: "#fff !important",
  height: '28px',
  padding: `${theme.spacing(1, 5)} !important`,
  display: 'flex !important',
  alignItems: 'center',
  justifyContent: 'center',
  width: 'fit-content',
  borderRadius: `${theme.spacing(1, 3)} !important`,
  textTransform: 'capitalize',
}))

export const CustomTabPanel = styled(TabPanel)(({ theme }) => ({
  padding: theme.spacing(4, 0),
}));


export const CustomCardTitle = styled(CardTitle)(({ theme }) => ({
  marginBottom: `${theme.spacing(4)} !important`,
}))

export const StyledTabTitle = styled(Box)(({ theme }) => ({
  color: theme.palette.white.main,
  fontWeight: 'bold',
  fontSize: '16px',
  backgroundColor: theme.palette.primary.main,
  padding: theme.spacing(1),
  textTransform: 'capitalize',
  marginBottom: `${theme.spacing(2)} !important`,
}))

export const SummaryIconWrapper = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.grey[200],
    borderRadius: '8px',
    padding: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(1.2),
    '& svg': {
        fontSize: '2.5rem',
        color: theme.palette.text.primary,
    },
}));
export const SummaryListIconWrapper = styled(Box)(({ theme }) => ({
    // backgroundColor: theme.palette.grey[200],
    padding: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // marginTop: theme.spacing(-1.5),
    '& svg': {
        fontSize: '2.5rem',
        color: theme.palette.text.primary,
    },
}));
export const CustomCard = styled(Box)(({theme}) => ({
  // marginBottom: theme.spacing(4),
}));

export const DocsContainer = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(2),
  width: '100%',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.palette.custom.borderRadius,
}));

export const DateContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: theme.spacing(3),
}));

export const DateTextField = styled(TextField)(({ theme }) => ({
  width: theme.spacing(20), // Fixed width for clean alignment
  margin: theme.spacing(0, 1),
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.shape.borderRadius,
    '& input': {
      textAlign: 'center',
      padding: '10px 8px', // Adjust padding to match the design
      fontSize: '0.9rem',
    },
    '& fieldset': {
      borderColor: '#e0e0e0', // Light grey border
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
    },
  },
}));

export const ButtonGroupContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2), 
  justifyContent: 'flex-end',
}));
export const RequiredAsterisk = styled('span')(({ theme }) => ({
  color: theme.palette.error.main,
}));
export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.white.main,
  },
}));
export const ErrorMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: '0.75rem',
  marginTop: theme.spacing(1),
}));
export const VerifiedButton = styled(Chip)(() => ({
  backgroundColor: "#4CAF50", 
  color: "#ffffff",
  height: "28px",
  // ... (rest of your styles)

  // This should correctly target the icon slot
  "& .MuiChip-icon": {
    color: "#ffffff",
    fontSize: "16px",
    marginLeft: "2px",
  },
  // ...
}));

